import { render } from "./aio-login-app.vue?vue&type=template&id=296a026e&scoped=true"
import script from "./aio-login-app.vue?vue&type=script&lang=js"
export * from "./aio-login-app.vue?vue&type=script&lang=js"

import "./aio-login-app.vue?vue&type=style&index=0&id=296a026e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-296a026e"]])

export default __exports__